<template>
  <div class="my-4 eddy-blue-card">
    <div>
      I’d like to build a lesson with the following topic prompt:
      <b>"{{ storedData ? storedData.topic.toLowerCase() : "" }}"</b>
    </div>
    <div>
      It is intended for <b>{{ storedData ? storedData?.grades : "" }}</b>
      <b>{{ storedData ? " - " + storedData?.subject : "" }}</b>
      <span v-if="storedData && storedData?.mindsets">
        that incorporates
        <b>{{ storedData?.mindsets }}</b></span
      >
      <span v-if="storedData && storedData?.skillsets">
        <b>{{ ", " + storedData?.skillsets + "." }}</b></span
      >
      <span
        v-if="storedData && storedData?.student_profile_term_name?.length > 0"
      >
        I have students with
        <b>{{ storedData?.student_profile_term_name?.join(" and ") }}</b> in my
        class.</span
      >
    </div>
  </div>
</template>

<script setup>
import { computed, defineExpose } from "vue";
import { useStore } from "vuex";

const store = useStore();

// Always reflect the current Vuex store value — no localStorage fallback here
// to avoid overwriting what the user just submitted.
const storedData = computed(() => store.state.formData);

// Kept for backward-compat with any parent that calls this via ref,
// but it's now a no-op since storedData is reactive.
const getPreviewData = () => {};

defineExpose({
  getPreviewData,
});
</script>

<style>
.eddy-blue-card {
  font-family: "League Spartan";
  background-color: var(--primary-blue);
  color: white;
  padding: 10px;
  border-radius: 10px;
  width: auto;
  text-align: center;
}
</style>
